import TrackingPageLinkModal from './TrackingPageLinkModal';
export default TrackingPageLinkModal;
